import { useTranslation } from 'react-i18next';
import SmartTooltip from '../../Report/SmartTooltip';
import RedirectLink from '@Components/RedirectLink';
import { usePermissionStore } from '../../../models/usePermissionModel';
import { PermissionNameEnum } from '@Types/permissions';
import { useLogReducerContext } from '../context';
import { LogTypeEnum } from '../../../types/log';

export const Violator = ({ logItem }: { logItem: any }) => {
  const { t } = useTranslation('log');
  const {
    state: { timeRange, type },
  } = useLogReducerContext();
  const { widthReadablePermission } = usePermissionStore();
  const quarantineReadPermission = widthReadablePermission(
    PermissionNameEnum.quarantine
  );
  const { violator = '', scanSourceKey, companyGuid } = logItem;

  if (type === LogTypeEnum.URLTRACKING) {
    return <SmartTooltip>{violator}</SmartTooltip>;
  }

  //scanSource value is service in es, refer to keyof _SERVICE_NAME_ARRAY
  if (
    //logic from old ui: isShowQuarantined, exclude teams_chat
    scanSourceKey === 'teams_chat' ||
    //logic from old ui: convertServiceToServiceID, exclude Exchange Server
    scanSourceKey === 'Exchange Server' ||
    !quarantineReadPermission
  ) {
    //teamsChat don't have quarantine
    return <SmartTooltip>{violator}</SmartTooltip>;
  }
  const queryString = `companyGuid=${companyGuid}&facets=${encodeURIComponent(
    JSON.stringify([
      {
        field: 'violator',
        values: [violator],
        type: 'terms',
      },
    ])
  )}&scanSource=${scanSourceKey}&timeRange=${encodeURIComponent(
    JSON.stringify(timeRange)
  )}`;

  return (
    <RedirectLink
      width="100%"
      href={`quarantine?${queryString}`}
      target="_blank"
      title={t('log.hint.viewViolator')}
      rel="noopener noreferrer"
    >
      <SmartTooltip>{violator}</SmartTooltip>
    </RedirectLink>
  );
};
